import { CastorMapper } from './mapper';

export class FieldsMapper implements CastorMapper<string[]> {
  map(o: string[]): { [p: string]: any } {
    if (!o) return {};

    return {
      fields: o.join(',')
    };
  }
}
